import { gql } from "@apollo/client";

export const FETCH_META_SHOP_ORDER_TAG_INCLUSIONS = gql`
  query FetchMetaShopOrderTagInclusions {
    me {
      metaShopOrderTagInclusions
    }
  }
`;

export const FETCH_TIK_TOK_SHOP_ORDER_TAG_INCLUSIONS = gql`
  query FetchTikTokShopOrderTagInclusions {
    me {
      tikTokShopOrderTagInclusions
    }
  }
`;

export const UPDATE_SHOP_ORDER_TAG_INCLUSIONS = gql`
  mutation UpdateShopOrderTagInclusions(
    $shop: String!
    $shopOrderTagInclusions: [JSONObject!]!
  ) {
    updateShopOrderTagInclusions(
      shop: $shop
      shopOrderTagInclusions: $shopOrderTagInclusions
    )
  }
`;
